export class LoginForm {
  constructor(public cprNr: string, public password: string) {}
}



// WEBPACK FOOTER //
// ./src/app/components/login/login-form.ts